export default "__VITE_PUBLIC_ASSET__dee659f5__"